import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Dialog, DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
export default function EditArrayVariableEditor({
  setOpen,
  setArray,
  array,
  index,
  setIndex,
  titles = [],
  header
}) {
  const { t } = useTranslation();
  const [value, setValue] = useState(array[index] ? array[index] : "");

  // delete item in array
  function handleDelete() {
    array.splice(index, 1);
    setArray(array);
    setOpen(false);
    setIndex(-1);
  }

  //update item in array
  function handleUpdate() {
    array.splice(index, 1, value)
    setArray(array);
    setOpen(false);
    setIndex(-1);
  }
  // added variable in array
  function handleAdd() {
    if (value?.length > 0) {
      setArray((oldArr) => [
        ...oldArr,
        value
      ]);
      setOpen(false);
      setIndex(-1);
    }
  }
  function handleAddKeyDown(event) {
    if(event.key === "Enter" && index === -1){
      handleAdd()
    }else if(event.key === "Enter" && index !== -1){
      handleUpdate();
    }
  }

  // close modal
  function handleClose() {
    setOpen(false);
    setIndex(-1);
  }
  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      <DialogTitle id="alert-dialog-title">
        <div className="modal-title">
          {t("ARRAY-VARIABLE-EDITOR."+header)}
          <Button
            data-test="cancelautom-button"
            onClick={handleClose}
            style={{ backgroundColor: "transparent" }}
          >
            <Close />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "400px" }}>
          <div className="form-element">
            {titles.length > 0 ? t("ARRAY-VARIABLE-EDITOR."+titles[0]) : t("ARRAY-VARIABLE-EDITOR.VALUE")}
            <TextField
              size="small"
              style={{ width: "100%" }}
              id="outlined-basic"
              variant="outlined"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              inputProps={{ style: { fontSize: 12 } }}
              onKeyDown={handleAddKeyDown}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "space-between",
          padding: "8px 24px 16px 24px",
        }}
      >
        {index === -1 ? (
          <>
            <Button
              variant="outlined"
              style={{
                float: "left",
                backgroundColor: "#D75E5E",
                borderRadius: "2px",
                color: "#fff",
                width: "45%",
                border: "none",
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              style={{
                float: "right",
                backgroundColor: "#46474E",
                borderRadius: "2px",
                color: "#fff",
                width: "45%",
                border: "none",
              }}
              onClick={handleAdd}
            >
              Add
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="outlined"
              style={{
                float: "left",
                backgroundColor: "#D75E5E",
                borderRadius: "2px",
                color: "#fff",
                width: "45%",
                border: "none",
              }}
              onClick={handleDelete}
            >
              Delete
            </Button>
            <Button
              variant="outlined"
              style={{
                float: "right",
                backgroundColor: "#46474E",
                borderRadius: "2px",
                color: "#fff",
                width: "45%",
                border: "none",
              }}
              onClick={handleUpdate}
            >
              Edit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
